module.exports = __webpack_public_path__ + "img/poster.ce648264.jpg";